import { PureComponent } from "react";
import Button from "segments/desktop/core-components/button/button";
import Bullets from "segments/desktop/core-components/bullets/bullets";
import classnames from "classnames";
import Colors from "styles/colors";
import { withSegmentsData } from "contexts/segment-context";
import Title from "segments/desktop/core-components/title/title";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import { withRouter } from "next/router";
import { withGenericConfig } from "/contexts/generic-config-context";
import {
  getDynamicSubTitleConfigForPath,
  getDynamicTitleConfigForPath
} from "/client/services/cluster-config-service/cluster-config-service";
import PictureComponent from "components/core/picture/picture-component";
import Icons from "segments/desktop/core-components/icons/icons";
import DefaultProps from "./default-props";
import { componentStyles } from "./full-paragraph.scss";

class FullParagraph extends PureComponent {
  getTextAlignBasedOnDeviceType = () => {
    const { isMobileBrowser, textAlign, mobileTextAlign } = this.props;
    if (!isMobileBrowser) return textAlign;

    return mobileTextAlign || textAlign;
  };

  getComponentInlineStyles() {
    const { textColor } = this.props;

    return {
      textAlign: this.getTextAlignBasedOnDeviceType(),
      color: textColor
    };
  }

  getTitleStyle = () => {
    const { titleWidth, topicText, spaceFromParagraph } = this.props;

    let style = { maxWidth: titleWidth };

    if (!topicText) {
      style = { ...style, marginTop: 0 };
    }

    if (spaceFromParagraph) {
      style = { ...style, marginBottom: spaceFromParagraph };
    }

    return style;
  };

  getButtonWrapperStyle = () => {
    const { buttonTopMargin } = this.props;

    if (!buttonTopMargin) return null;

    return {
      marginTop: buttonTopMargin
    };
  };

  renderTopic = () => {
    const { topic, topicBottomMargin } = this.props;
    const { text: topicText, color, image } = topic;

    if (image?.src || image?.href) {
      return (
        <div className="full-paragraph-topic-image-wrapper" style={{ marginBottom: topicBottomMargin }}>
          <PictureComponent {...image} />
        </div>
      );
    }

    if (topicText) {
      return (
        <div className="full-paragraph-topic" style={{ color: Colors[color], marginBottom: topicBottomMargin }}>
          {topicText}
        </div>
      );
    }

    return null;
  };

  render() {
    const {
      body,
      bodyColor,
      buttonConfig,
      bulletsConfig,
      textSize,
      titleSize,
      titleColor,
      isFirstSegment,
      withDynamicParagraphTitle,
      withDynamicParagraphSubtitle,
      title,
      titleClassName,
      clusterConfig,
      activePagePath,
      titleIcon,
      iconsConfig
    } = this.props;

    const inlineComponentStyles = this.getComponentInlineStyles();

    const titleToUse =
      (withDynamicParagraphTitle && getDynamicTitleConfigForPath(clusterConfig, activePagePath)) || title;
    const subTitleToUse =
      (withDynamicParagraphSubtitle && getDynamicSubTitleConfigForPath(clusterConfig, activePagePath)) || body;

    return (
      <div className="full-paragraph" style={inlineComponentStyles}>
        {this.renderTopic()}
        {titleToUse && (
          <div className="title-wrapper" style={this.getTitleStyle()}>
            <Title
              title={titleToUse}
              titleSize={titleSize}
              titleColor={titleColor}
              titleIcon={titleIcon}
              isFirstSegment={isFirstSegment}
              titleClassName={titleClassName}
            />
          </div>
        )}

        {subTitleToUse && (
          <div className="paragraph-body-wrapper">
            <Paragraph body={subTitleToUse} bodyColor={bodyColor} textSize={textSize} isFirstSegment={isFirstSegment} />
          </div>
        )}

        {bulletsConfig && (
          <div className={classnames("bullets-wrapper", this.getTextAlignBasedOnDeviceType())}>
            <Bullets {...bulletsConfig} />
          </div>
        )}

        {iconsConfig && (
          <div className={classnames("icons-wrapper", this.getTextAlignBasedOnDeviceType())}>
            <Icons {...iconsConfig} />
          </div>
        )}

        {buttonConfig && buttonConfig.buttonType && (
          <div
            className={classnames("button-wrapper", this.getTextAlignBasedOnDeviceType())}
            style={this.getButtonWrapperStyle()}
          >
            <Button {...buttonConfig} />
          </div>
        )}

        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

FullParagraph.defaultProps = DefaultProps;

export default withSegmentsData(withRouter(withGenericConfig(FullParagraph)));
